// extracted by mini-css-extract-plugin
module.exports = {"root":"ui_root__1hQEh"};